import { render, staticRenderFns } from "./SettingsControl.vue?vue&type=template&id=5896624b&"
import script from "./SettingsControl.vue?vue&type=script&lang=js&"
export * from "./SettingsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports